import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import UAvatar from 'modules/user/UAvatar.component';
import CoinStat from 'modules/stats/coinStat.component';
import RStat from 'modules/stats/rStat.component';
import * as navigationActions from 'modules/navigation/navigation.actions';
import { getUser, cacheCommunity } from 'modules/auth/auth.actions';
import Tooltip from 'modules/tooltip/tooltip.component';
import { computeUserPayout } from 'app/utils/rewards';
import { SIDE_NAV_PADDING } from 'styles/layout';
import {
  Row,
  View,
  SecondaryText,
  CTALink,
  Header,
  InlineLink,
  Pressable,
} from 'modules/styled';

export class NavProfile extends Component {
  static propTypes = {
    user: PropTypes.object,
    earnings: PropTypes.object,
    actions: PropTypes.object,
    auth: PropTypes.object,
    community: PropTypes.object,
    communities: PropTypes.object,
  };

  componentDidUpdate(lastProps) {
    const { auth, actions, user } = this.props;
    if (
      auth.community !== lastProps.auth.community &&
      user &&
      (!user.relevance || user.relevance.community !== auth.community)
    ) {
      actions.getUser();
    }

    if (user && auth.community !== lastProps.auth.community) {
      actions.cacheCommunity(auth.community);
    }
  }

  render() {
    const { user, earnings, actions, community, communities } = this.props;
    if (!user) return null;

    // TODO optimize this so its not on every render?
    let pendingPayouts = 0;
    earnings.pending.forEach((id) => {
      const earning = earnings.entities[id];
      const com = communities[earning.community];
      pendingPayouts += computeUserPayout(earning, com);
    });

    return (
      <View
        sx={{
          flex: 1,
          variant: 'borders.navBorder',
          borderBottomWidth: 1,
          p: [2, SIDE_NAV_PADDING],
        }}
      >
        <Row sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
          <Header>{user.name}</Header>
          <InlineLink
            inline={1}
            hu
            to="/user/wallet"
            nativeAction={() => actions.goToTab('wallet')}
          >
            <CTALink sx={{ color: 'blue' }}>My Wallet</CTALink>
          </InlineLink>
        </Row>
        <View sx={{ mt: [2, 3] }} />
        <Row sx={{ alignItems: 'center' }}>
          <UAvatar
            user={user}
            size={9}
            noName
            goToProfile={() => actions.goToTab('myProfile')}
          />
          <View sx={{ pl: 2 }}>
            <Row>
              <Tooltip
                data={{
                  position: 'right',
                  text: `This is your reputation in the ${community?.name} community`,
                }}
              >
                <RStat size={4} mr={2} user={user} align="center" />
              </Tooltip>
              <Pressable
                to="/user/wallet"
                inline={1}
                nativeAction={() => actions.goToTab('wallet')}
              >
                <Tooltip
                  data={{
                    position: 'right',
                    text: 'Get coins by upvoting quality links.\n',
                  }}
                >
                  <CoinStat size={4} user={user} isOwner={true} align="center" />
                </Tooltip>
              </Pressable>
            </Row>

            <View sx={{ mt: 2, alignItems: 'baseline' }}>
              <Tooltip
                data={{
                  position: 'right',
                  text: 'These are your projected earnings for upvoting quality posts.\nRewards are paid out 3 days after a link is posted.',
                }}
              >
                <SecondaryText sx={{ lineHeight: 14, fontSize: 1 }}>
                  Estimated Rewards:{' '}
                  <CoinStat
                    size={1}
                    mr={1.5}
                    fs={1.5}
                    inline={1}
                    secondary
                    c={'black'}
                    amount={pendingPayouts}
                  />
                </SecondaryText>
              </Tooltip>
            </View>
          </View>
        </Row>

        <Row sx={{ alignItems: 'baseline', mt: 3 }}>
          <InlineLink
            to="/user/wallet"
            c={'blue'}
            hu
            nativeAction={() => {
              actions.push('getTokens');
            }}
            webAction={(e) => {
              e.preventDefault();
              actions.showModal('getTokens');
            }}
          >
            <CTALink sx={{ color: 'blue' }}>Get Tokens</CTALink>
          </InlineLink>
        </Row>
      </View>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  user: state?.auth?.user,
  earnings: state.earnings,
  communities: state.community?.communities,
  community: state.community?.communities?.[state.community?.active],
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      ...navigationActions,
      cacheCommunity,
      getUser,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(NavProfile);
